import React from 'react';

const AdminHome = () => {
  return (
    <div>
     Admin Home
    </div>
  );
};

export default AdminHome;
